/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.feature.rollouts.app.rpc.BetaAccessRolloutRpc
 */
import * as References from './BetaAccessRolloutRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerMutation } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.feature.rollouts.app.rpc.BetaAccessRolloutRpc#enroll
 */
export const ENROLL_MUTATION_FIELD_NAME =
  'com_hubspot_feature_rollouts_app_rpc_BetaAccessRolloutRpc_enroll';
export const ENROLL_MUTATION: RegisteredQuery<
  'result',
  References.EnrollRequestType,
  References.EnrollResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: ENROLL_MUTATION_FIELD_NAME,
  args: [
    'rolloutId',
    'enrollType',
    'needsUngating',
    'shouldUpdateMultiAccounts',
  ],
  fetcher(
    request: References.EnrollRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.EnrollResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.enrollRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.feature.rollouts.app.rpc.BetaAccessRolloutRpc#updateEnrollType
 */
export const UPDATE_ENROLL_TYPE_MUTATION_FIELD_NAME =
  'com_hubspot_feature_rollouts_app_rpc_BetaAccessRolloutRpc_updateEnrollType';
export const UPDATE_ENROLL_TYPE_MUTATION: RegisteredQuery<
  'result',
  References.UpdateEnrollTypeRequestType,
  References.UpdateEnrollTypeResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UPDATE_ENROLL_TYPE_MUTATION_FIELD_NAME,
  args: ['request'],
  fetcher(
    request: References.UpdateEnrollTypeRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UpdateEnrollTypeResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.updateEnrollTypeRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.feature.rollouts.app.rpc.BetaAccessRolloutRpc#leave
 */
export const LEAVE_MUTATION_FIELD_NAME =
  'com_hubspot_feature_rollouts_app_rpc_BetaAccessRolloutRpc_leave';
export const LEAVE_MUTATION: RegisteredQuery<
  'result',
  References.LeaveRequestType,
  References.LeaveResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: LEAVE_MUTATION_FIELD_NAME,
  args: [
    'rolloutId',
    'enrollType',
    'needsUngating',
    'shouldUpdateMultiAccounts',
  ],
  fetcher(
    request: References.LeaveRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.LeaveResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.leaveRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});
